import React from 'react'

import "./nav.css";

import {Link} from 'react-router-dom';
export default function Nav() {
	return (
		<>
		<div classNameName="row d-flex justify-content-start align-items-center"style={{width:"100%",display:"flex",marginLeft:"28px"}}>
<Link to="/">
<img src="https://atanurag.github.io/Portfolio/oraimg.png" 
style={{height:"65px",width:"63px",position:"fixed",
 top: "0",zIndex:" 999"
  
}}/></Link></div>

			{ /*<input type="checkbox" id="active"/>
			    <label htmlFor="active" classNameName="menu-btn"><svg xmlns="http://www.w3.org/2000/svg" classNameName="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} classNameName="svgi">
			  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
			</svg></label>
			    <div classNameName="wrapper">
			      <ul>
			<li><Link to="/">Home</Link></li>
			<li><Link to="/projects">Projects</Link></li>
			
			<li><Link to="/certificates">Certificates</Link></li>
			<li><Link to="/skills">Skills</Link></li>
			<li><Link to="/about">About Me</Link></li>
			<li><Link to="/contact">Contact</Link></li>
			</ul>
</div>*/}

<input type="checkbox" id="active"/>
    <label for="active" className="menu-btn"><span></span></label>
    <label for="active" className="close"></label>
    <div className="wrapper">
      <ul>
			<li 
			><Link to="/" >Home</Link></li>
			<li className="dis"><Link to="/about">About </Link></li>
			<li><Link to="/projects">Projects</Link></li>
			
			<li><Link to="/certificates">Certificates</Link></li>
			<li><Link to="/skills">Skills</Link></li>
			
			<li><Link to="/contact">Contact</Link></li>
			</ul>
</div>

		</>
	);
}